import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiSmile3dSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_89)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.64 14.69c.342-.377.842-.59 1.36-.59h8c.518 0 1.018.213 1.36.59.356.393.535.967.346 1.566a4.6 4.6 0 0 1-1.05 1.76c-1.1 1.172-2.8 1.884-4.656 1.884-1.857 0-3.556-.712-4.657-1.884a4.6 4.6 0 0 1-1.049-1.76 1.59 1.59 0 0 1 .346-1.566m2.016 2.094a2.9 2.9 0 0 1-.578-.884h7.844c-.127.312-.32.61-.578.884-.724.771-1.93 1.316-3.344 1.316-1.415 0-2.62-.545-3.344-1.316"
                    fill={`url(#${_uniqueId}paint0_radial_8745_89)`}
                    suppressHydrationWarning
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 12C1 2.375 2.375 1 12 1s11 1.375 11 11-1.375 11-11 11S1 21.625 1 12m5.64 2.69c.342-.377.842-.59 1.36-.59h8c.518 0 1.018.213 1.36.59.356.393.535.967.346 1.566a4.6 4.6 0 0 1-1.05 1.76c-1.1 1.172-2.8 1.884-4.656 1.884-1.857 0-3.556-.712-4.657-1.884a4.6 4.6 0 0 1-1.049-1.76 1.59 1.59 0 0 1 .346-1.566m8.86-6.94c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75M6.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75"
                    fill={`url(#${_uniqueId}paint1_radial_8745_89)`}
                    suppressHydrationWarning
                />
                <path
                    d="M8.078 15.9c.127.312.32.61.578.884.724.771 1.93 1.316 3.344 1.316 1.415 0 2.62-.545 3.344-1.316.257-.274.451-.572.578-.884z"
                    fill={`url(#${_uniqueId}paint2_radial_8745_89)`}
                    suppressHydrationWarning
                />
                <path
                    d="M15.5 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
                    fill={`url(#${_uniqueId}paint3_radial_8745_89)`}
                    suppressHydrationWarning
                />
                <path
                    d="M6.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75"
                    fill={`url(#${_uniqueId}paint4_radial_8745_89)`}
                    suppressHydrationWarning
                />
            </g>
            <path
                d="M15.5 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
                fill="#9E7F10"
            />
            <path
                d="M6.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75"
                fill="#9E7F10"
            />
            <path
                d="M8 14.1c-.518 0-1.018.213-1.36.59a1.59 1.59 0 0 0-.345 1.566 4.6 4.6 0 0 0 1.049 1.76c1.1 1.172 2.8 1.884 4.656 1.884 1.857 0 3.556-.712 4.657-1.884a4.6 4.6 0 0 0 1.049-1.76c.19-.6.01-1.173-.346-1.566A1.84 1.84 0 0 0 16 14.1z"
                fill="#9E7F10"
            />
            <path
                d="M8 14.1c-.518 0-1.018.213-1.36.59a1.59 1.59 0 0 0-.345 1.566 4.6 4.6 0 0 0 1.049 1.76c1.1 1.172 2.8 1.884 4.656 1.884 1.857 0 3.556-.712 4.657-1.884a4.6 4.6 0 0 0 1.049-1.76c.19-.6.01-1.173-.346-1.566A1.84 1.84 0 0 0 16 14.1z"
                fill="#9E7F10"
            />
            <path d="M12 16.5c-2.285 0-5-.5-5.5-2h11c-.5 1.5-3.214 2-5.5 2" fill="white" />
            <path d="M12 18c-1.662 0-3.636.25-4 1l4 .5 4-.5c-.364-.75-2.338-1-4-1" fill="white" />
            <path
                d="M8 14.1c-.518 0-1.018.213-1.36.59a1.59 1.59 0 0 0-.345 1.566 4.6 4.6 0 0 0 1.049 1.76c1.1 1.172 2.8 1.884 4.656 1.884 1.857 0 3.556-.712 4.657-1.884a4.6 4.6 0 0 0 1.049-1.76c.19-.6.01-1.173-.346-1.566A1.84 1.84 0 0 0 16 14.1z"
                stroke="#79610C"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_89`}
                    x={1}
                    y={-2.75}
                    width={25.75}
                    height={25.75}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={3.75} dy={-3.75} />
                    <feGaussianBlur stdDeviation={3.75} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_89" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_89`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_89`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_89`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_89`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint4_radial_8745_89`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiSmile3dSize24Glyph.displayName = 'EmojiSmile3dSize24Glyph';
